export default "__VITE_ASSET__CsCAxwbM__"